export const UserLocalStorageKeys = {
  ID: 'id',
  USERNAME: 'username',
  ROLE: 'role',
  EMAIL: 'email',

  NSFW_POLICY: 'nsfw_policy',
  P2P_ENABLED: 'peertube-videojs-webtorrent_enabled',

  AUTO_PLAY_VIDEO: 'auto_play_video',
  AUTO_PLAY_NEXT_VIDEO: 'auto_play_next_video',
  AUTO_PLAY_VIDEO_PLAYLIST: 'auto_play_video_playlist',

  THEME: 'theme',
  LAST_ACTIVE_THEME: 'last_active_theme',

  VIDEO_LANGUAGES: 'video_languages'
}

export const UserTokenLocalStorageKeys = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  TOKEN_TYPE: 'token_type'
}
